import { useTranslation } from "react-i18next";
import PageBanner from "../Shared/PageBanner";
import bannerBg from "../assets/img/Banner/Top-Image8.jpg";
import Details from "../components/News/NewsDetails/Details";
import { useGetBannersQuery } from "../app/feature/API/CMS";
import React from "react";

const NewsDetails = () => {
  const {t,i18n} = useTranslation()
  const {data} = useGetBannersQuery('newsDetails')

  return (
    <>
      <PageBanner title={data?.title} bannerBg={data?.image} currentPage={data?.title} />
      <Details/>
    </>
  );
};

export default React.memo(NewsDetails);
